import React, { memo } from 'react';
import cardStyles from 'assets/css/Card.module.css';
import aceLibraryStyles from 'assets/css/AceLibrary.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import CardLink, { CardLinkIconWrap } from 'Components/Card/CardLink';
import { IconAngleRight, IconPhone, IconCart } from '@ace/react-icons';

function DigitalTextbooksCard(props) {
    //local var(s)
    const { 
        HasSetPassword: hasSetPassword, 
        Links: links, 
        UpgradeRequired: upgradeRequired, 
        UpgradeText: upgradeText,
        UpgradeIcon: upgradeIcon,
        ActionLink: actionLink
    } = props.data;

    const displayProps = {
        showUpgrade: upgradeRequired,
        showCreatePassword: !upgradeRequired && !hasSetPassword,
        showLinks: (!upgradeRequired && links && links.length) ? true : false,
        showLibrary: !upgradeRequired && hasSetPassword
    };

    //render
    return (
        <div className={cardStyles.cardBodyDefault}>
            {displayProps.showUpgrade && <UpgradePartial links={links} upgradeText={upgradeText} actionLink={actionLink} upgradeIcon={upgradeIcon} />}
            {displayProps.showCreatePassword && <CreatePasswordPartial />}
            {displayProps.showLinks && <DigitalTextbookLinks links={links} hasSetPassword={hasSetPassword} />}
            {displayProps.showLibrary && <ACELibraryAppContainerPartial />}
        </div>
    )
}

const CreatePasswordPartial = memo(
    () => {
        return (
            <div className={aceLibraryStyles.wrap}>
                <div className={aceLibraryStyles.inner}>
                    <div className={aceLibraryStyles.header}>
                        <h4 className={aceLibraryStyles.headerTitle}>Create your password</h4>
                    </div>
                    <div className={aceLibraryStyles.content}>
                        <div className={aceLibraryStyles.content}>
                            <p>To access your eBook you must first create a password within the ACE Library.</p>
                        </div>
                        <div className={aceLibraryStyles.ctaWrap}>
                            <CardLink
                                linkText={"Create Your eBook Password"}
                                linkUrl={"/myace/ace-library.aspx"}
                                linkIcon={<IconAngleRight />}
                                target="_blank"
                                className={buttonStyles.floating} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

const DigitalTextbookLinks = memo(({links, hasSetPassword}) => {
    if (hasSetPassword) {
        //allow links
        return (
            <>
                <p style={{color: "#5f6567", fontWeight: 600}}>Sign in with your eBook password</p>
                <div className={aceLibraryStyles.eBookLinksWrapper}>
                    {links.map(link => 
                        (<CardLink
                            linkText={link.CardLinkText}
                            linkUrl={link.CardLinkUri}
                            linkIcon={<IconAngleRight />}
                            target="_blank"
                            className={buttonStyles.stroke} />)
                    )}
                </div>
                <div className={aceLibraryStyles.changePasswordLink}>
                    <CardLink
                        linkText={"Change Password"}
                        linkUrl={"/myace/ace-library.aspx"}
                        linkIcon={<IconAngleRight />}
                        target="_blank"
                        className={buttonStyles.floating} />
                </div>
            </>
        )
    } else {
        //disabled links
        return (
            <div className={aceLibraryStyles.eBookLinksWrapper}>
                <DisabledTextBooksLinks links = {links} />
            </div>
        )
    }    
});

const DisabledTextBooksLinks = ({links}) => {
    return (
        links.map(link => 
            (<div className={aceLibraryStyles.eBookDisabledLink}>
                <span className={`${buttonStyles.stroke} ${buttonStyles.strokeDisabled}`}>
                    {<span dangerouslySetInnerHTML={{__html: link.CardLinkText}} />}
                    <CardLinkIconWrap><IconAngleRight /></CardLinkIconWrap>
                </span>
            </div>)
        )
    )
}

const UpgradePartial = memo(
    ({links, upgradeText, actionLink, upgradeIcon}) => {
        const upgradeIcons = {
            IconPhone: IconPhone,
            IconCart: IconCart
        }
        const UpgradeIcon = upgradeIcons[upgradeIcon ?? 'IconPhone'];

        return (
            <>
                <div className={aceLibraryStyles.eBookLinksWrapper}>
                    <DisabledTextBooksLinks links = {links} />
                </div>
                <div className={aceLibraryStyles.upgradeRequired}>
                    <UpgradeIcon className={aceLibraryStyles.purchasePhoneIcon} fill={"#02263C"} />
                    {<span dangerouslySetInnerHTML={{__html: upgradeText}} />}
                </div>
                <CardLink
                    linkText={actionLink?.CardLinkText ?? "Call To Purchase"}
                    linkUrl={actionLink?.CardLinkUri ?? "tel:888-825-3636;"}
                    linkIcon={<IconAngleRight />}
                    style={{margin: "1rem 0"}}
                    className={`${buttonStyles.purchase}`}
                    target= {!!actionLink ? "_blank" : "_self"} />
            </>
        );
    }
)

const ACELibraryAppContainerPartial = memo(
    () => {
        return (
            <div className={aceLibraryStyles.wrap}>
                <div className={aceLibraryStyles.inner}>
                    <div className={aceLibraryStyles.header}>
                        <h4 className={aceLibraryStyles.headerTitle}>ACE Library App</h4>
                    </div>
                    <div className={aceLibraryStyles.content}>
                        <div className={aceLibraryStyles.content}>
                            <p>When viewing your digital textbooks on a mobile device, download the ACE Library app for the best viewing experience.</p>
                            <ol className={aceLibraryStyles.steps}>
                                <li>
                                    <div style={{width: "1rem", marginRight: "1rem"}}><IconAngleRight /></div>
                                    Download the ACE Library App and sign in with your eBook password.
                                </li>
                            </ol>
                        </div>
                        <div className={aceLibraryStyles.ctaWrap}>
                            <CardLink
                                linkText={"Get Started"}
                                linkUrl={"/myace/ace-library.aspx"}
                                linkIcon={<IconAngleRight />}
                                target="_blank"
                                className={buttonStyles.floating} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

export default DigitalTextbooksCard;
